import React from "react";
import { withStyles } from '@material-ui/core/styles';

import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import { Select,Button,Paper } from "@material-ui/core";
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import ls from 'local-storage'

const styles = theme => ({
  root: {
    flexGrow: 1,
    overflow: 'hidden',
  },
  button: {
    margin: theme.spacing.unit / 2,
    marginTop: 0,
    marginBottom: 0,
  },
  paper: {
    padding: theme.spacing.unit,
    color: theme.palette.text.secondary,
  },
  card: {
      //minHeight: 165,
  },
});

class PracticeSetup extends React.Component {
    state ={
        value: 0,
        practice_name:'',
        practice_manager:'',
        practice_address1:'',
        practice_address2:'',
        practice_address3:'',
        practice_address4:'',
        practice_address5:'',
        practice_postcode:'',
        practice_publicphone:'',
        practice_email:'',
        nhsregion:'',
        sitenumber:'',
        location:'',
        webediusername:'',
        webedipassword:'',
        webediurl:'',
        providername:'',
        defaultprovider:'',
    };

    constructor(props) {
        super(props);
        this.props=props;
        this.props.socket.emit("load_practice_setup",{practiceid:1,authenticator:ls.get("authenticator")}); 
    }

    componentDidMount(){
        this._isMounted = true;

/*        this.props.socket.on("load_practice_setup_result",(data)=>{
            console.log(data);

            for(var k in data){
                this.setState({[k]:data[k]});
            }
        });*/

        this.props.socket.on("load_practice_setup_result",(d)=>{
            if (this._isMounted) {
                //console.log(d);
                for(var k in d.detail){
                    this.setState({[k]:d.detail[k]});
                }

                this.setState({nhsregion: d.data.nhs_region});
                this.setState({sitenumber: d.data.nhs_ediori});
                this.setState({location: d.data.nhs_ediloc});
                this.setState({webediusername: d.data.nhs_ediusername});
                this.setState({webedipassword: d.data.nhs_edipassword});
                this.setState({webediurl: d.data.nhs_ediurl});
                this.setState({providername: d.data.nhs_edipname});

                //this.setState({config:d});
                //console.log(this.state);
            }
        });        
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    handleChange = (event) => {
        this.setState({ [event.target.name]:event.target.value });
    };

saveSetup = e =>{
    var setupvars = {
        practicename:this.state.practice_name,
        practicemanager:this.state.practice_manager,
        building:this.state.practice_address1,
        street:this.state.practice_address2,
        district:this.state.practice_address3,
        town:this.state.practice_address4,
        county:this.state.practice_address5,
        postcode:this.state.practice_postcode,

        phone:this.state.practice_publicphone,
        email:this.state.practice_email,

        data_nhs_region:this.state.nhsregion,
        data_nhs_ediori:this.state.sitenumber,
        data_nhs_ediloc:this.state.location,
        data_nhs_ediusername:this.state.webediusername,
        data_nhs_edipassword:this.state.webedipassword,
        data_nhs_ediurl:this.state.webediurl,
        data_nhs_edipname:this.state.providername,
        //data_defaultprovider:this.state.defaultprovider,
    }
    /*for(var k in setupvars){
        console.log(setupvars[k]);
    }*/
        this.props.socket.emit("save_practice_setup",{details:setupvars,authenticator:ls.get("authenticator")});
    
}

  render() {
    const { classes } = this.props;
    //console.log(this.state);
    return (
    <div className={classes.root}>
     <Grid container style={{ padding: 2 }} spacing={1}>
        <Grid item xs={12}>
            <Paper className={classes.paper}>
                <Button variant="contained" color="primary" className={classes.button} onClick={this.saveSetup}>Save</Button>
            </Paper>        
        </Grid>
        <Grid item sm={12} md={5}>
                <Paper className={classes.paper}>
                    <Typography variant="h5" gutterBottom>
                        Practice Details
                    </Typography>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <TextField
                            name="practice_name"
                            label="Practice Name"
                            className={classes.textField}
                            value={this.state.practice_name}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <TextField
                            name="practice_manager"
                            label="Practice Manager"
                            className={classes.textField}
                            value={this.state.practice_manager}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <TextField
                            name="practice_address1"
                            label="Building"
                            className={classes.textField}
                            value={this.state.practice_address1}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <TextField
                            name="practice_address2"
                            label="Street"
                            className={classes.textField}
                            value={this.state.practice_address2}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <TextField
                            name="practice_address3"
                            label="District"
                            className={classes.textField}
                            value={this.state.practice_address3}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <TextField
                            name="practice_address4"
                            label="Town"
                            className={classes.textField}
                            value={this.state.practice_address4}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <TextField
                            name="practice_address5"
                            label="County"
                            className={classes.textField}
                            value={this.state.practice_address5}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </FormControl>
                    <FormControl className={classes.formControl} fullWidth={true}>
                        <TextField
                            name="practice_postcode"
                            label="Postcode"
                            className={classes.textField}
                            value={this.state.practice_postcode}
                            onChange={this.handleChange}
                            margin="normal"
                        />
                    </FormControl>
                </Paper>
        </Grid>
        <Grid item sm={12} md={5} lg={4} xl={4}>
            <Grid container spacing={16}>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Typography variant="h5" gutterBottom>
                            Contact Details
                        </Typography>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <TextField
                                name="practice_publicphone"
                                label="Phone"
                                className={classes.textField}
                                value={this.state.practice_publicphone}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <TextField
                                name="practice_email"
                                label="Email"
                                className={classes.textField}
                                value={this.state.practice_email}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </FormControl>
                    </Paper>
                </Grid>
                <Grid item xs={12}>
                    <Paper className={classes.paper}>
                        <Typography variant="h5" gutterBottom>
                            NHS Details
                        </Typography>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <InputLabel htmlFor='nhsregion'>NHS Region</InputLabel>
                            <Select
                                
                                value={this.state.nhsregion}
                                onChange={this.handleChange}
                                inputProps={{
                                    name:'nhsregion',
                                    id:'nhsregion',
                                }}
                            >
                                <MenuItem value={"england"}>England</MenuItem>
                                <MenuItem value={"wales"}>Wales</MenuItem>
                                <MenuItem value={"iom"}>IOM</MenuItem>
                            </Select>
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <TextField
                                name="sitenumber"
                                label="Site Number (ori)"
                                className={classes.textField}
                                value={this.state.sitenumber}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <TextField
                                name="location"
                                label="Location (loc)"
                                className={classes.textField}
                                value={this.state.location}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <TextField
                                name="webediusername"
                                label="WebEDI Username"
                                className={classes.textField}
                                value={this.state.webediusername}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </FormControl>
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <TextField
                                name="webedipassword"
                                label="WebEDI Password"
                                className={classes.textField}
                                value={this.state.webedipassword}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </FormControl>
                        {/*<FormControl className={classes.formControl} fullWidth={true}>
                            <TextField
                                name="webediurl"
                                label="WebEDI URL"
                                className={classes.textField}
                                value={this.state.webediurl}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </FormControl>*/}
                        <FormControl className={classes.formControl} fullWidth={true}>
                            <TextField
                                name="providername"
                                label="Provider Name"
                                className={classes.textField}
                                value={this.state.providername}
                                onChange={this.handleChange}
                                margin="normal"
                            />
                        </FormControl>
                        {/*<FormControl className={classes.formControl} fullWidth={true}>
                            <InputLabel htmlFor='defaultprovider'>Default Provider</InputLabel>
                            <Select
                                value={this.state.defaultprovider}
                                onChange={this.handleChange}
                                inputProps={{
                                    name:'defaultprovider',
                                    id:'defaultprovider',
                            }}>
                                <MenuItem value={1}>Tim</MenuItem>
                                <MenuItem value={2}>Richard</MenuItem>
                                <MenuItem value={3}>Some other fool</MenuItem>
                            </Select>
                        </FormControl>*/}
                    </Paper>
                </Grid>
            </Grid>
        </Grid>
      </Grid>
    </div>
    );
  }
}

export default withStyles(styles)(PracticeSetup);